<template>
  <!-- 对话框 -->
  <el-dialog title="上下线统计" :visible.sync="show" :before-close="closeDialog" width="70%">

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">




      <el-table-column prop="id" label="id">
      </el-table-column>


      <el-table-column prop="coordinate_name" label="地址">
      </el-table-column>


      <el-table-column prop="time.YmdHis" label="时间">
      </el-table-column>

      <el-table-column prop="type.alias" label="类型">
      </el-table-column>



    </el-table>


    <!-- 分页组件 -->
    <div style="text-align: right;">
      <el-pagination layout="prev, pager, next" :total="result_data_children.count" @current-change="pages_function">
      </el-pagination>
    </div>

    <div style="display: flex;justify-content: center">
      <el-button @click="closeDialog">关闭</el-button>
    </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean,
      'data': '',
      'name':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.search_data_children.driver_code=_this.data;

        console.log(_this.data);

        _this.getDriverTime();

      },

    },
    data() {
      return {

        show: false,

        tableData: [],


        //翻页数据
        search_data_children: {
          page: 1,
          limit: 10,
          driver_code: ''
        },

        result_data_children: [],
        search_rules_children: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      toOrder(billno){

        this.$router.push({
          path: '/substituteDrivingOrder',
          query: {
            billno: billno
          }
        })

      },
      // 获取钱包信息
      getDriverTime() {
        _this.$post(
            '/driver/driverTimeControlLists',
            _this.search_data_children,
            _this.search_rules_children
          )
          .then(res => {

            // 将获取到的数据赋值

            _this.tableData = res.data;
            _this.result_data_children=res;



          }).catch((err) => {

          })
      },
      // 关闭方法
      closeDialog() {

        _this.show = false;


      },

      //翻页组件的回调
      pages_function(val) {
        _this.search_data_children.page = val;

        //初始化列表
        _this.getDriverTime();

      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>